import React from 'react';
import FinCheckProvider from "../../components/finCheck/FinCheckProvider";
import FinCheckContent from "../../components/finCheck/FinCheckContent";


const FinCheck = () => {
    return <FinCheckProvider>
                <FinCheckContent/>
           </FinCheckProvider>
}

export default FinCheck;